export const getApiErrorMessage = (error: unknown, fallback: string): string => {
  const data = (error as { data?: unknown })?.data;
  const message = (data as { message?: unknown })?.message;

  if (typeof message === 'string' && message.trim()) {
    return message;
  }

  if (Array.isArray(message)) {
    const joined = message.filter((item): item is string => typeof item === 'string').join('; ');

    if (joined.trim()) {
      return joined;
    }
  }

  return fallback;
};

const CREDENTIALS_ERROR_KEY = 'auth.signIn.errors.credentials';
const NETWORK_ERROR_KEY = 'auth.signIn.errors.network';
const UNKNOWN_ERROR_KEY = 'auth.signIn.errors.unknown';

type SignInError = {
  status?: number | string;
};

export const getSignInErrorMessage = (
  error: SignInError | undefined,
  fallback = UNKNOWN_ERROR_KEY,
): string => {
  const status = error?.status;

  if (status === 401 || status === 403 || status === 404) {
    return CREDENTIALS_ERROR_KEY;
  }

  if (
    status === 'FETCH_ERROR' ||
    status === 'TIMEOUT_ERROR' ||
    (typeof status === 'number' && status >= 500 && status <= 599)
  ) {
    return NETWORK_ERROR_KEY;
  }

  return fallback;
};
